import Vue from 'vue';
Vue.prototype.$maidian = (eventId = "10000000", pageName = document.title, extra = {}) => {
  Vue.prototype.$webBP.requestCustom({
    eventId, //	事件ID
    curTime: new Date().getTime(), //	发生时间
    pageName, //页面名称
    sendTime: new Date().getTime(), //发送时间
    url: window.location.href, //当前路径
    extra //扩展参数
  });
}



// WEBPACK FOOTER //
// ./src/plugin/buryingPointWeb.js